var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ppv-modal-header"},[_c('div',{staticClass:"ppv-modal-header-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('button',{staticClass:"ppv-modal-header-close",on:{"click":_vm.handleClose}},[_c('v-icon',[_vm._v(_vm._s(_vm.icons.mdiClose))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }